import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { getShortAmount, isCorporatePOC } from 'src/utils/commonMethods'
import { Tooltip, Zoom } from '@mui/material'
import Modal from 'src/components/common/Modal'
import { GET_DASHBOARD_POLICIES_GROUP_AGGREGATE } from 'src/services/individualService'
import { CircularProgress } from '@material-ui/core'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { useQuery } from '@apollo/client'
import {
  INSURANCE_CATEGORIES,
  POLICY_STATUS_TYPES,
  POLICY_TYPE_ALL,
} from 'src/utils/constants/common'
import { getDashboardFilterValue } from 'src/utils/commonMethods/searchPersistence'
import { useDispatch, useSelector } from 'react-redux'
import { COLORS } from 'src/utils/Themes/colors'
import RenewModal from 'src/components/common/RenewPolicy/RenewModal'
import TrackRenewedPolicyForm from 'src/components/common/RenewPolicy/TrackRenewedPolicyForm'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import { getBuyType } from 'src/utils/commonMethods/buyPolicy'
import RenewNow from 'src/assets/PolicyTile_Images/RenewNow.svg'
import RenewedPolicy from 'src/assets/PolicyTile_Images/RenewedPolicy.svg'
import { useHistory } from 'react-router-dom'
import { updateBuyPolicyTitle } from 'src/actions'

const PolicyDetailsCard = ({
  policyDetails,
  handleViewAll,
  clientId,
  expiryType,
  expiredFilterParams,
  clientType,
  city,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const [showRenewalModal, setShowRenewalModal] = useState(false)
  const [showTrackForm, setShowTrackForm] = useState(false)
  const [isTracking, setIsTracking] = useState(false)
  const [trackClick, setTrackClick] = useState(false)

  const { viewPolicyDashboardFilters, userInfo } = useSelector((state) => {
    return {
      viewPolicyDashboardFilters:
        state?.searchPersistenceReducer?.viewPolicyDashboardFilters,
      userInfo: state?.userInfo,
    }
  })
  const role = userInfo?.userInfo?.userData?.roles

  // eslint-disable-next-line
  const [filters, setFilters] = useState({
    selectedStatus: getDashboardFilterValue(
      viewPolicyDashboardFilters,
      'selectedStatus',
      POLICY_STATUS_TYPES?.expired
    ),
  })

  // eslint-disable-next-line
  const [searchValue, setSearchValue] = useState(
    getDashboardFilterValue(viewPolicyDashboardFilters, 'searchValue', '')
  )

  const {
    loading: dashboardGroupedPoliciesLoading,
    error: dashboardGroupedPoliciesError,
    data: dashboardGroupedPolicies,
    refetch,
  } = useQuery(
    GET_DASHBOARD_POLICIES_GROUP_AGGREGATE(
      clientId,
      policyDetails?.policyType,
      filters?.selectedStatus,
      searchValue,
      expiryType,
      expiredFilterParams?.year || '',
      expiredFilterParams?.policyType === POLICY_TYPE_ALL
        ? ''
        : expiredFilterParams?.policyType || '',
      expiredFilterParams?.subType || '',
      city || ''
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  useEffect(() => {
    refetch()
  }, [filters?.selectedStatus, searchValue, expiredFilterParams, refetch])

  if (dashboardGroupedPoliciesLoading)
    return (
      <div>
        <CircularProgress />
      </div>
    )

  if (dashboardGroupedPoliciesError)
    return (
      <>
        <GraphQlErrors
          error={dashboardGroupedPoliciesError}
          routeValue={'back'}
        />
      </>
    )

  const policies =
    dashboardGroupedPolicies?.getDashboardPoliciesGroupedData?.policies

  const handleClick = () => {
    const insuranceType =
      policyDetails?.insuranceType === INSURANCE_NAMES?.MOTOR_INSURANCE
        ? policyDetails?.productSubType
        : policyDetails?.insuranceType
    const url = getBuyType(insuranceType)

    const insuranceName = policies?.[0]?.productSubType
      ? policies?.[0]?.productSubType
      : policies?.[0]?.insuranceType

    if (
      url !== INSURANCE_CATEGORIES?.HEALTH ||
      url !== INSURANCE_CATEGORIES?.BIKE ||
      url !== INSURANCE_CATEGORIES?.MOTOR
    ) {
      dispatch(updateBuyPolicyTitle(insuranceName))
      history.push('/individual/dashboard/buyPolicy/life')
    } else {
      history.push(`/individual/dashboard/buyPolicy/${url}`)
    }
  }

  const handleUploadRenewalModal = () => {
    setShowRenewalModal(true)
  }

  const closeRenewalModal = () => {
    setShowRenewalModal(false)
  }

  const handleTrackClick = (isTrack) => {
    setShowTrackForm(true)
    setIsTracking(isTrack)
    setTrackClick(isTrack)
  }

  const closeTrackModalForm = () => {
    setShowTrackForm(false)
  }

  return (
    <>
      <div>
        {showRenewalModal ? (
          <Modal
            id='modal'
            bgcolor={'#FFF'}
            ordered={showRenewalModal}
            width={'30%'}
            left={'32%'}
            top={'30%'}
            borderRadius={'10px'}
            modelClosed={closeRenewalModal}
          >
            <RenewModal
              closeRenewModal={closeRenewalModal}
              policyDetails={policies}
              handleClick={handleClick}
            />
          </Modal>
        ) : null}
        {showTrackForm ? (
          <Modal
            id='modal'
            bgcolor={'#FFF'}
            ordered={showTrackForm}
            width={'90%'}
            left={'5%'}
            top={'7%'}
            borderRadius={'10px'}
            modelClosed={closeTrackModalForm}
          >
            <TrackRenewedPolicyForm
              closeModal={closeTrackModalForm}
              policyData={policies?.[0]}
              isTracking={isTracking}
              trackClick={trackClick}
              clientType={clientType}
            />
          </Modal>
        ) : null}
        <div
          id='policyCard'
          className={classes.mainContainer}
          onClick={() => {
            handleViewAll(policyDetails, true)
          }}
        >
          <div className={classes.headingContainer}>
            <div id='viewAllProviderDetails' className={classes.heading}>
              <div className={classes.providerImageContainer}>
                <img
                  src={policyDetails?.logo}
                  className={classes.providerImage}
                  alt='Logo'
                />
              </div>

              <Tooltip
                TransitionComponent={Zoom}
                placement='top'
                title={policyDetails?.policyType}
                arrow
              >
                <div className={classes.providerName}>
                  {policyDetails?.policyType} :
                </div>
              </Tooltip>

              <div className={classes.providerValueContent}>
                <span className={classes.providerValue}>
                  {policyDetails?.statistics?.totalNumberOfPolicies}
                </span>
                <span className={classes.providerValueText}>Policies</span>
              </div>
            </div>

            <div className={classes.headingIcons}>
              <div
                id='viewAll'
                className={classes.viewAll}
                onClick={() => {
                  handleViewAll(policyDetails, true)
                }}
              >
                <div>
                  {policyDetails?.statistics?.totalNumberOfPolicies === 1 ? (
                    <span>View</span>
                  ) : (
                    <span>View All</span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <div className={classes.textContent}>
                <span>Total Premium Paid</span>
              </div>
              <div className={classes.textValue}>
                <span>{getShortAmount(policyDetails?.totalPremium)}</span>
              </div>
            </div>
            <div className={classes.policiesContent}>
              {policyDetails?.statistics?.expiring > 0 && (
                <div className={classes.policyStatusContainer}>
                  <span className={classes.statusCount}>
                    {policyDetails?.statistics?.expiring}
                  </span>
                  <span>Near to Expire</span>
                </div>
              )}
              {policyDetails?.statistics?.expired > 0 && (
                <div className={classes.policyStatusContainer}>
                  <span className={classes.statusCount}>
                    {policyDetails?.statistics?.expired}
                  </span>
                  <span>Expired</span>
                </div>
              )}
              {policyDetails?.statistics?.digitalizing > 0 && (
                <div className={classes.policyStatusContainer}>
                  <span className={classes.digitalizingCount}>
                    {policyDetails?.statistics?.digitalizing}
                  </span>
                  <span>Digitalizing</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.renewContainer}>
        {isCorporatePOC(role) && policies?.length === 1 && (
          <div>
            {policies?.map((policyData) => (
              <>
                {(policyData?.status === POLICY_STATUS_TYPES?.expired ||
                  (policyData?.isNearToExpire &&
                    policyData?.status === POLICY_STATUS_TYPES?.active)) && (
                  <div className={classes.renewedPolicy}>
                    <img
                      src={RenewNow}
                      alt='renewNowButton'
                      className={classes.renewNowButton}
                      onClick={() => handleUploadRenewalModal(false)}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        )}

        {isCorporatePOC(role) && policies?.length === 1 && (
          <div>
            {policies?.map((policyData) => (
              <>
                {policyData?.status === POLICY_STATUS_TYPES?.underRenewal && (
                  <div className={classes.renewedPolicyContainer}>
                    <img
                      src={RenewedPolicy}
                      alt='renewedPolicyButton'
                      className={classes.renewedPolicyButton}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        )}

        {isCorporatePOC(role) && policies?.length === 1 && (
          <div>
            {policies?.map((policyData) => (
              <>
                {policyData?.status === POLICY_STATUS_TYPES?.renewed && (
                  <div className={classes.trackTile}>
                    <span
                      className={classes.trackTileTextHead}
                      onClick={() => handleTrackClick(true)}
                    >
                      TRACK
                    </span>
                  </div>
                )}
              </>
            ))}
          </div>
        )}
        {isCorporatePOC(role) && policies?.length === 1 && (
          <div>
            {policies?.map((policyData) => (
              <>
                {policyData?.status === POLICY_STATUS_TYPES?.active &&
                  policyData?.oldPolicyId && (
                    <div className={classes.trackTile}>
                      <span
                        className={classes.trackTileTextHead}
                        onClick={() => handleTrackClick(true)}
                      >
                        TRACK
                      </span>
                    </div>
                  )}
              </>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
export default PolicyDetailsCard
const useStyles = makeStyles({
  mainContainer: {
    border: '1px solid #D8D8D8',
    borderRadius: '10px',
    marginBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    cursor: 'pointer',
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 10px',
    flexWrap: 'wrap',
    height: '100%',
  },
  heading: {
    display: 'flex',
    padding: '10px',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
  },
  headingIcons: {
    display: 'flex',
    padding: '10px',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  providerImageContainer: {
    minWidth: '30px',
    width: '10%',
  },
  providerImage: {
    width: '35px',
    height: '35px',
  },
  providerName: {
    fontSize: '14px',
    fontWeight: '400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '80%',
    maxWidth: '150px',
    '@media only screen and (max-width: 350px)': {
      maxWidth: '120px',
    },
  },
  providerValueContent: {
    display: 'grid',
    background: '#E8E8E8',
    padding: '6px',
    borderRadius: '3px',
    minWidth: '30px',
    width: '40px',
  },
  providerValue: {
    fontSize: '18px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    color: '#B92250',
    justifyContent: 'center',
  },
  providerValueText: {
    fontSize: '9px',
    fontWeight: '400',
    color: '#595959',
    textAlign: 'center',
  },
  contentContainer: {
    display: 'flex',
    padding: '10px 20px',
    background: '#F1EAED',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '0px 0px 10px 10px',
  },
  Notification: {
    width: '15px',
  },
  Share: {
    width: '14px',
  },
  viewAll: {
    fontSize: '12px',
    color: '#B92250',
    fontWeight: '500',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  content: {
    textAlign: 'center',
    padding: '0px 7px',
  },
  policiesContent: {
    textAlign: 'initial',
  },
  textContent: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    display: 'flex',
    gap: '3px',
  },
  policyStatusContainer: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    display: 'flex',
    gap: '3px',
    marginBottom: '5px',
    '&:hover': {
      color: '#B92250',
      padding: '5px',
      transform: 'translateX(0px) scale(1.25)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
    },
  },
  textValue: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '21px',
    padding: '5px 0px 0px 0px',
  },
  textExpired: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '16px',
    color: '#D80027',
    padding: '5px 0px 0px 0px',
  },
  statusCount: {
    color: '#D80027',
    fontSize: '13px',
    fontWeight: '700',
  },
  digitalizingCount: {
    color: '#1192CC',
    fontSize: '13px',
    fontWeight: '700',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    // gap: '2px',
    '@media (min-width: 1024px)': {
      gridTemplateColumns: 'repeat(2, 1fr)', // Two columns for screens larger than 'md'
    },
  },
  renewedPolicyContent: {
    marginTop: '-15px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'end',
  },
  editIcon: {
    color: COLORS.DARK_PINK,
    marginLeft: '10px',
    cursor: 'pointer',
    marginTop: '22px',
    width: '22px',
  },
  editMenu: {
    backgroundColor: 'transparent',
    border: '0',
  },
  renewNowButton: {
    width: '100px',
  },
  renewedPolicy: {
    padding: '0px 5px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  renewedPolicyButton: {
    width: '250px',
  },
  trackTile: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '-9px',
  },
  trackTileTextHead: {
    color: '#B92250',
    padding: '10px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '14px',
    letterSpacing: '0em',
    textDecoration: 'underline',
  },
  renewedPolicyContainer: {
    padding: '0px 5px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  renewContainer: {
    marginTop: '-15px',
  },
})
